import { Card, Input, Button, Typography } from "@material-tailwind/react";
import Navbar from "../../../component/Navbar";
import { useEffect, useState } from "react";
import { dataGet, dataPost } from "../../../network";
import {
  userPostData,
  userGetData,
  countryAutoComplete,
} from "../../../network/const";
import { Dialog } from "../../../component/items/Dialog";
import { dialogDataTypes } from "../../../component/items/itemDataType";
import { useLocation, useNavigate } from "react-router-dom";
import { UserModel } from "../../../network/dataType";
import SearchableSelect from "../../../component/items/SearchableSelect";

export default function UserAdd() {
  const navigate = useNavigate();
  const dataState: { state: UserModel | null } = useLocation();
  const [open, setOpen] = useState(false);

  const [dialogData, setDialogData] = useState({
    title: "",
    btnText: "",
    description: "",
    status: false,
  });

  const [countries, setCountries] = useState<
    { countryId: number; countryName: string }[]
  >([]);

  const [formState, setFormState] = useState({
    username: "",
    email: "",
    password: "",
    role: "Admin",
    country: "",
    countryId: "",
    jobTitle: "",
    companyName: "",
  });

  const [errorState, setErrorState] = useState({
    username: "",
    email: "",
    password: "",
    role: "",
    country: "",
    countryId: "",
    jobTitle: "",
    companyName: "",
  });

  const action = dataState.state?.id ? "Edit" : "Add";
  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      if (dataState.state?.id) {
        const res = await dataGet(`${userGetData}/${dataState.state.id}`, {});
        if (res.status && res.data) {
          setFormState({
            username: res.data.username ?? "",
            email: res.data.email ?? "",
            password: "",
            role: res.data.role ?? "Admin",
            country: res.data.country ?? "",
            countryId: res.data.countryId?.toString() ?? "",
            jobTitle: res.data.jobTitle ?? "",
            companyName: res.data.companyName ?? "",
          });
        }
      }
    };
    fetchUser();
  }, [dataState]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    setFormState({ ...formState, [e.target.name]: e.target.value });
  };

  const fetchCountries = async () => {
    const res = await dataGet(countryAutoComplete, {});
    if (res.status) {
      setCountries(res.data);
    }
  };

  const initDialog = (data: dialogDataTypes) => {
    setOpen(true);
    setDialogData({
      title: data.title,
      btnText: data.btnText,
      description: data.description,
      status: data.status ?? false,
    });
  };

  const submitData = async () => {
    let isValid = true;
    setErrorState({
      username: "",
      email: "",
      password: "",
      role: "Admin",
      country: "",
      countryId: "",
      jobTitle: "",
      companyName: "",
    });

    if (!formState.username) {
      errorState.username = "Please check Name field";
      isValid = false;
    }

    if (!formState.email) {
      errorState.email = "Please check email field";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formState.email)) {
      errorState.email = "Email address is invalid";
      isValid = false;
    }

    if (action === "Add" && !formState.password) {
      errorState.password = "Please check password field";
      isValid = false;
    }

    if (
      action === "Add" &&
      formState.password &&
      formState.password.length < 6
    ) {
      errorState.password = "Password must be at least 6 characters long";
      isValid = false;
    }

    if (formState.role === "User") {
      if (!formState.jobTitle) {
        errorState.jobTitle = "Job title is required.";
        isValid = false;
      }
      if (!formState.companyName) {
        errorState.companyName = "Company name is required.";
        isValid = false;
      }
      if (!formState.countryId) {
        errorState.country = "Please select a country.";
        isValid = false;
      }
    }

    if (!isValid) {
      setErrorState({ ...errorState });
      return;
    }

    const url = dataState.state?.id
      ? `${userPostData}/${dataState.state.id}`
      : userPostData;

    const data = await dataPost(url, formState);

    if (data.status) {
      initDialog({
        description: data.message,
        title: data.title,
        btnText: "OK",
        status: data.status,
      });
    } else {
      initDialog({
        description: data.message,
        title: data.title,
        btnText: "OK",
      });
    }
  };

  return (
    <>
      <Navbar />
      <div className="mt-20">
        <Card color="transparent" className="items-center" shadow={false}>
          <Typography variant="h4" color="blue-gray">
            User {action}
          </Typography>
          <form className="mt-8 mb-2 p-5 max-w-screen-lg w-full">
            <div className="max-w-2xl mx-auto p-6 bg-white rounded shadow">
              <div className="mb-4 flex flex-col gap-4">
                <Input
                  required
                  error={!!errorState.username}
                  size="lg"
                  label="Name"
                  id="username"
                  onChange={handleChange}
                  value={formState.username}
                  crossOrigin={undefined}
                />
                {errorState.username && (
                  <div className="text-red-600 text-sm mt-px">
                    {errorState.username}
                  </div>
                )}

                <Input
                  required
                  error={!!errorState.email}
                  size="lg"
                  label="Email"
                  id="email"
                  onChange={handleChange}
                  value={formState.email}
                  crossOrigin={undefined}
                />
                {errorState.email && (
                  <div className="text-red-600 text-sm mt-px">
                    {errorState.email}
                  </div>
                )}
                {action === "Add" && (
                  <Input
                    type="password"
                    size="lg"
                    label="Password"
                    id="password"
                    error={!!errorState.password}
                    onChange={handleChange}
                    value={formState.password}
                    crossOrigin={undefined}
                  />
                )}
                {errorState.password && (
                  <div className="text-red-600 text-sm mt-px">
                    {errorState.password}
                  </div>
                )}

                {/* Role Type Radio Buttons */}
                <div className="pt-2">
                  {/* Small grey label */}
                  <p className="text-sm text-gray-500 mb-1">Role Type</p>

                  {/* Radio buttons */}
                  <div className="flex gap-6">
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="role"
                        value="Admin"
                        checked={formState.role === "Admin"}
                        onChange={handleChange}
                        className="accent-blue-600"
                      />
                      Admin
                    </label>
                    <label className="flex items-center gap-2">
                      <input
                        type="radio"
                        name="role"
                        value="User"
                        checked={formState.role === "User"}
                        onChange={handleChange}
                        className="accent-blue-600"
                      />
                      User
                    </label>
                  </div>
                </div>

                {/* Show only for User */}
                {formState.role === "User" && (
                  <>
                    <Input
                      required
                      error={!!errorState.jobTitle}
                      size="lg"
                      label="Job Title"
                      id="jobTitle"
                      onChange={handleChange}
                      value={formState.jobTitle}
                      crossOrigin={undefined}
                    />
                    {errorState.jobTitle && (
                      <div className="text-red-600 text-sm mt-px">
                        {errorState.jobTitle}
                      </div>
                    )}

                    <Input
                      required
                      error={!!errorState.companyName}
                      size="lg"
                      label="Company Name"
                      id="companyName"
                      onChange={handleChange}
                      value={formState.companyName}
                      crossOrigin={undefined}
                    />
                    {errorState.companyName && (
                      <div className="text-red-600 text-sm mt-px">
                        {errorState.companyName}
                      </div>
                    )}

                    {/* <Select
                      id="country"
                      name="country"
                      labelText="Country"
                      isRequired={true}
                      value={formState.countryId}
                      placeholder="Country"
                      options={countries.map((c) => ({
                        label: c.countryName,
                        value: c.countryId.toString(),
                      }))}
                      handleChange={(value: string) => {
                        const selected = countries.find(
                          (c) => c.countryId.toString() === value
                        );
                        setFormState({
                          ...formState,
                          country: selected?.countryName || "",
                          countryId: selected?.countryId.toString() || "",
                        });
                      }}
                    /> */}
                    <SearchableSelect
                      id="country"
                      labelText="Country"
                      isRequired={true}
                      value={formState.countryId}
                      placeholder="Select Country"
                      options={countries.map((c) => ({
                        label: c.countryName,
                        value: c.countryId.toString(),
                      }))}
                      handleChange={(value: string) => {
                        const selected = countries.find(
                          (c) => c.countryId.toString() === value
                        );
                        setFormState({
                          ...formState,
                          country: selected?.countryName || "",
                          countryId: selected?.countryId.toString() || "",
                        });
                      }}
                      error={!!errorState.country}
                    />

                    {errorState.country && (
                      <p className="text-red-600 text-sm mt-px">
                        {errorState.country}
                      </p>
                    )}
                  </>
                )}
              </div>

              <div className="flex space-x-2">
                <Button className="mt-6" fullWidth onClick={() => navigate(-1)}>
                  Cancel
                </Button>
                <Button
                  className="mt-6"
                  color="green"
                  fullWidth
                  onClick={submitData}
                >
                  {action}
                </Button>
              </div>
            </div>
          </form>
        </Card>

        <Dialog
          open={open}
          handleOpen={() => {
            setOpen(false);
            if (dialogData.status) navigate(-1);
          }}
          title={dialogData.title}
          description={dialogData.description}
          buttonText={dialogData.btnText}
        />
      </div>
    </>
  );
}
